import(/* webpackMode: "eager" */ "/app/apps/quarries/app/[locale]/not-found.tsx");
